import {
  SocialAccount,
  ObjectTypeDetail,
  ContentVisibility,
  Seo,
  ProfileImage,
  ConferencePromo,
  MinimumCreatorDetail,
  ContactInformation,
} from '@fs/zion-rootstech'

export const MinimumDashboardCreatorDetail = `
  ${MinimumCreatorDetail}
  fragment MinimumDashboardCreatorDetail on CreatorDetail {
    associatedUser
    ...MinimumCreatorDetail
  }
`

const FullCreatorDetail = `
  ${ProfileImage}
  ${SocialAccount}
  ${ObjectTypeDetail}
  ${ContactInformation}
  ${ContentVisibility}
  ${ConferencePromo}
  ${Seo}
  fragment FullCreatorDetail on CreatorDetail {
    alternateLocales
    associatedUser
    biography
    contentLocale
    creatorType
    exhibitorDetail {
      id
      name
    }
    honors
    id
    name
    profileImage {
      ...ProfileImage
    }
    secondaryLocale
    sourceId
    seo {
      ...Seo
    }
    socialAccounts {
      ...SocialAccount
    }
    submissions {
      ...ConferencePromo
    }
    title
    contactInformation @include(if: $includeContactInfo) {
      ...ContactInformation
    }
    url
    visibility {
      ...ContentVisibility
    }
  }
`
export default FullCreatorDetail
